import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  Grid,
  CardHeader,
  CardContent,
  Divider,
} from '@material-ui/core';
import { format } from 'date-fns';
import { NumberHandler } from '../../util/NumberHandler';
import Spinner from '../../util/Spinner';
import { useRootStore } from '../../../stores/BridgeProvider';
import { filterCaseInsensitive, dateSort } from '../../util/TableUtils';
import { CustomTable } from '../../common/CustomTable';

const voucherColumnsConfig = [
  {
    Header: 'Voucher #',
    accessor: 'VoucherNumber',
    id: 1,
    // Filter: FilterPlaceholder,
  },
  {
    Header: 'Contact',
    accessor: 'ContactName',
    id: 2,
  },

  {
    Header: 'Due Date',
    accessor: d => format(d.DueDate, 'MM/DD/YYYY'),
    Cell: ({ row: { original } }) => (
      <div style={{ textAlign: 'center' }}>
        {original.DueDate ? format(original.DueDate, 'MM/DD/YYYY') : 'N/A'}
      </div>
    ),
    id: 4,
    sortType: dateSort,
    width: 70,
  },
  {
    Header: 'Total',
    accessor: d => d.Amount,
    Cell: ({ row }) =>
      row.original.Amount ? (
        <NumberHandler
          num={row.original.Amount}
          currency="$"
          justify="flex-end"
          float={2}
        />
      ) : (
        'N/A'
      ),
    id: 5,
    width: 70,
  },
  {
    Header: 'Amount Paid',
    accessor: d => d.AmountPaid || 'N/A',
    Cell: ({ row }) =>
      row.original.AmountPaid ? (
        <NumberHandler
          num={row.original.AmountPaid}
          currency="$"
          justify="flex-end"
          float={2}
        />
      ) : (
        'N/A'
      ),
    id: 6,
    width: 70,
  },
  {
    Header: 'Date',
    accessor: d => format(d.VoucherDate, 'MM/DD/YYYY'),
    Cell: ({ row: { original } }) => (
      <div style={{ textAlign: 'center' }}>
        {format(original.VoucherDate, 'MM/DD/YYYY')}
      </div>
    ),
    id: 3,
    sortType: dateSort,
    width: 70,
  },
];

const UnpaidVouchers = () => {
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const { dataStore } = useRootStore();
  const vouchers = dataStore.voucherArray;
  useEffect(() => {
    const initialActions = async () => {
      await dataStore.retrieveAllVouchers();
      setLoading(false);
    };
    initialActions();
  }, []);
  if (isLoading) return <Spinner />;

  const filterOutDirectPayments = vouchers.filter(
    ({ VoucherTypeId }) => VoucherTypeId < 5,
  );

  const filteredVouchersByStatus = filterOutDirectPayments.filter(
    ({ StatusId }) => StatusId > 1 && StatusId < 6,
  );

  const filteredVouchersByPayment = filteredVouchersByStatus.filter(
    ({ Amount, AmountPaid }) => parseFloat(AmountPaid) !== parseFloat(Amount),
  );

  const dateSortedVouchers = filteredVouchersByPayment
    .slice()
    .sort(({ DueDate: a }, { DueDate: b }) => {
      const a1 = new Date(a).getTime();
      const b1 = new Date(b).getTime();
      if (a1 < b1) return -1;
      if (a1 > b1) return 1;
      return 0;
    });

  // remove future vouchers

  return (
    <Grid item lg={12} xs={12}>
      <Card style={{ height: '100%' }}>
        <CardHeader title="Unpaid Vouchers" />
        <Divider />
        <CardContent style={{ padding: 0 }} className="LIAMTEST">
          <CustomTable
            data={dateSortedVouchers}
            columns={voucherColumnsConfig}
            defaultPageSize={5}
            trClassName="react-table-hover-row"
            resizable={false}
            filterable={false}
            showPageSizeOptions={false}
            noDataText="No vouchers"
            defaultFilterMethod={filterCaseInsensitive}
            disableQueryParams
            hideHeader
            getTrProps={({ row }) => ({
              onClick: () =>
                history.push(`/vouchers/${row.original.VoucherId}`),
            })}
          />
        </CardContent>
      </Card>
    </Grid>
  );
};

export default UnpaidVouchers;
